export const IMPORT_PLAN = "IMPORT_PLAN";
export const IMPORT_PLAN_SUCCESS = "IMPORT_PLAN_SUCCESS";
export const IMPORT_PLAN_FAIL = "IMPORT_PLAN_FAIL";
